import React from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';

export function AboutPage() {
  return (
    <>
      <SEO
        title="Om os | KELFAE LOFTER ApS"
        description="Om os – Kelfae Lofter ApS har mangeårig knowhow i branchen og stor erfaring i at samarbejde med arkitekter, entreprenører og tømmerhandlere."
      />

      <section className="bg-neutral-100 border-b border-neutral-200 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-neutral-900 bg-[#7FDCA7]/30 px-3 py-1 rounded-full border border-[#7FDCA7]/50 inline-block">
              Mangeårig Knowhow
            </span>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-neutral-900 font-serif-heading tracking-tight">
              Om os – Kelfae Lofter ApS
            </h1>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6 text-xs sm:text-sm text-neutral-700 leading-relaxed">
              <p className="text-base sm:text-lg font-semibold text-neutral-900">
                Hos Kelfae Lofter ApS har vi en mangeårig knowhow i branchen, hvor vi har stor erfaring i at samarbejde med branchens fagfolk såsom arkitekter, entreprenører og tømmerhandlere. Vi har altid lagt stor vægt på at være en seriøs, kvalitetsbevidst og konkurrencedygtig virksomhed.
              </p>

              <h2 className="text-lg font-bold text-neutral-900 font-serif-heading pt-2 border-t border-neutral-200">
                Stort program af akustiklofter fra førende producenter
              </h2>
              <p>
                Der stilles høje krav til efterklangstiden i kontorlokaler, undervisningslokaler og storkøkkener samt alle andre store og åbne rum. Derfor er det vigtigt at forsyne lokalerne med akustikdæmpende lofter. Vi har et stort program i akustiklofter, og derfor kan vi opfylde disse krav. Samtidig kan vi tilbyde en elegant og æstetisk løsning på en langt bedre akustik.
              </p>
              <p>
                Vi er importør af akustikplader fra den svenske producent Parafon AB og den tyske producent Knauf AMF GMBH & CO KG, som hører til blandt nogle af Europas førende producenter af akustiklofter. Dermed kan vi tilbyde en bred vifte af lydabsorberende løsninger, som er i høj kvalitet, og som er fremstillet af bæredygtige materialer.
              </p>

              <h2 className="text-lg font-bold text-neutral-900 font-serif-heading pt-2 border-t border-neutral-200">
                Få mere information om lydabsorberende loftløsninger
              </h2>
              <p>
                Du er velkommen til at indhente mere information om vores lydabsorberende loftløsninger, og vi laver gerne en analyse af det eller de lokaler, hvor der er behov for en bedre akustik. Vores analyse og rådgivning er din sikkerhed for, at du vælger den rette løsning. Herefter kan vi udarbejde et uforpligtende tilbud.
              </p>
              <p>
                Du kan ringe til os på telefon{' '}
                <a href="tel:43712540" className="text-neutral-900 font-bold hover:text-[#69C892] underline whitespace-nowrap">
                  (+45) 43 71 25 40
                </a>{' '}
                for at få en snak med en af vores dygtige medarbejdere. Du kan også skrive til os på e-mail{' '}
                <a href="mailto:jlh@kelfae.dk" className="text-neutral-900 font-bold hover:text-[#69C892] underline whitespace-nowrap">
                  jlh@kelfae.dk
                </a>
                . Vi ser frem til at høre fra dig.
              </p>
            </div>

            <div className="lg:col-span-5 space-y-6">
              <div className="rounded-2xl overflow-hidden border border-neutral-200 shadow-sm relative group">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/6ff16b38-fa18-408f-9a5d-f4f108c00990/aa1-dsc7053-hdr-445.jpg"
                  alt="KELFAE LOFTER - Professionelle akustikløsninger"
                  className="w-full h-64 sm:h-80 object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end p-6">
                  <p className="text-white text-xs sm:text-sm font-semibold font-serif-heading">
                    Kvalitetsbevidst og seriøs leverandør af loft- og akustikløsninger
                  </p>
                </div>
              </div>

              <div className="bg-neutral-50 border border-neutral-200 p-8 rounded-2xl space-y-6 shadow-sm">
                <h3 className="text-base font-bold text-neutral-900 font-serif-heading uppercase tracking-wider border-b border-neutral-200 pb-3">
                  Hvorfor vælge KELFAE LOFTER?
                </h3>
                <ul className="space-y-4 text-xs text-neutral-700">
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-check text-[#7FDCA7] mt-1 text-sm font-bold" aria-hidden="true" />
                    <span>Mangeårig brancheerfaring & teknisk knowhow</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-check text-[#7FDCA7] mt-1 text-sm font-bold" aria-hidden="true" />
                    <span>Direkte importør fra Europa-førende producenter</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-check text-[#7FDCA7] mt-1 text-sm font-bold" aria-hidden="true" />
                    <span>Fokus på bæredygtige og miljøcertificerede materialer</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-check text-[#7FDCA7] mt-1 text-sm font-bold" aria-hidden="true" />
                    <span>Specialister i T-skinnesystemer og nedhængte lofter</span>
                  </li>
                </ul>

                <div className="pt-4 border-t border-neutral-200">
                  <Link
                    to="/kontakt"
                    className="w-full py-3.5 bg-[#7FDCA7] hover:bg-[#69C892] text-neutral-950 font-bold text-xs rounded-xl transition-all text-center block shadow-sm"
                  >
                    Kontakt os for rådgivning
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
